import { Events } from '@APP/events/app-events';
import { requires } from '@APP/mixins/dependency';
import { Question } from '@APP/model/question';
import { Option, ReactiveList } from '@APP/model/reactive-list';
import { eventBus } from '@APP/utils/event-bus';
import { BaseService } from './base-service';
import { IDataProviderService } from './data-provider';
import { QuestionsService } from './questions-service';

type DEPS = {
  questionsService: QuestionsService;
};

const BOAT_TYPE_QID = 'boatType';

@requires(QuestionsService.serviceName)
class MotorTypeDataProvider
  extends BaseService<DEPS>
  implements IDataProviderService {
  static serviceName = 'motorTypeDataProvider';

  private boatTypeQuestion?: Question;
  private motorTypes: ReactiveList<string, any> = new ReactiveList('motorType');
  private allOptions: Option<string, any>[] = [];

  constructor() {
    super();
    eventBus().on(
      Events.questionIntermediateChangeEvent(BOAT_TYPE_QID),
      (v) => {
        this.boatTypeQuestion =
          this.deps.questionsService.model.getQuestionById(BOAT_TYPE_QID);
        this.buildOptions();
        this.populateList(v);
      },
    );
  }

  getList(name: string): ReactiveList<any, any> {
    if (name !== 'motorType') {
      throw new Error('Unknown list');
    }
    return this.motorTypes;
  }

  private buildOptions() {
    const rawOpts: `${string}::${string}`[] =
      this.boatTypeQuestion!.metadata.motorOptions;
    this.allOptions = rawOpts.map(o => o.split('::')).map(([label, value]) => ({
      label,
      value,
    }));
  }

  private populateList(boatTypeValue: string) {
    const { motorByBoatType } = this.boatTypeQuestion!.metadata;
    const motorOpts: string[] = motorByBoatType[boatTypeValue] || [];
    this.motorTypes.setState('pending');
    const availableOptions = this.allOptions.filter((o) => motorOpts.includes(o.value));
    this.motorTypes.options = availableOptions;
    const { selection } = this.motorTypes;
    if (selection && availableOptions.indexOf(selection) < 0) {
      this.motorTypes.select(undefined);
    }
    this.motorTypes.setState('ready');
  }
}

export { MotorTypeDataProvider };

MotorTypeDataProvider.define();
